export default __webpack_public_path__ + "static/media/guest_14_01.67aa4b06.jpg";